import {api} from "../../Service"
import { useEffect, useState } from "react"
import Project from "../Project"
import {Loading, Ul} from "./style"

const Projects = () =>{

    const [projects, setProjects] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(()=>{
        api.get("v6/projects",{
            headers:{
                Authorization: `Bearer s5AmMWswuqd3pxyIcOrgXNuE`
            }
        })
        .then(res => {
            setProjects(res.data.projects)
        })
        setTimeout(()=> setIsLoading(false), 1500)
    },[])

    return(
        <>
        <Ul>
            {
                isLoading ? 
                    <Loading/>
                :
                projects.map(project => <Project project={project} key={project.name}/>)
            }
        </Ul>
        </>
    )
}

export default Projects